import { render, staticRenderFns } from "./PhotoBookInteriorSpread.vue?vue&type=template&id=2d0dbaef&scoped=true"
import script from "./PhotoBookInteriorSpread.vue?vue&type=script&lang=js"
export * from "./PhotoBookInteriorSpread.vue?vue&type=script&lang=js"
import style0 from "./PhotoBookInteriorSpread.vue?vue&type=style&index=0&id=2d0dbaef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0dbaef",
  null
  
)

export default component.exports